import { SldpSettings } from './sldp';

export interface UserGlobalInterfaceConfig {
  sldpSettings?: SldpSettings;
  [key: string]: unknown;
}
